import { Checkbox, Box, Modal, Button, Grid, Paper, FormLabel, TextField, FormHelperText, FormControlLabel, FormControl, RadioGroup, Radio, Autocomplete } from '@mui/material'
import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import CancelIcon from '@mui/icons-material/Cancel';
import { styled } from '@mui/material/styles';
import axios_supplier from '../../../../services/utility/axios-supplier';
import axiosDiscountSchemes from '../../../../services/utility/axios-discount-schemes';
import PageLoader from '../../../../components/shared/PageLoader';
import { setDiscountSchemeState } from '../../../../store/slices/discountScheme';
import { handleModalState, setNewPriceModal } from '../../../../store/slices/modals';
import CommonPopUp from '../../../products/addEditPdc/pdc-tabs/CommonPopUp';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import { setMemberCode } from '../../../../store/slices/supplierMemberAccounts';

const Item = styled(Paper)(({ theme }) => ({
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    boxShadow: "none"
}));

function AddEditSupplier({ onShow, size = '', onHide, onSubmitDate }) {
    
    const { discountScheme_container } = useSelector((state) => {
        return {
            discountScheme_container: state.discountSchemes,
            sma_container: state.smas,
        }
    });
    const dispatch = useDispatch();

    const [state, setState] = useState({
        supplierListModal: false,
        pageLoader: false,
        defaultmode: false,
        formValid: true,
        supplierDetail: discountScheme_container.hasEditSupplier ? discountScheme_container.hasEditSupplier.supplier : null
    })

    const [included, setIncluded] = useState(true);

    const [supplier, setSupplier] = useState({
        supplier_options: [],
        supplier_selected: discountScheme_container.hasEditSupplier ? { id: discountScheme_container.hasEditSupplier.supplierId, name: discountScheme_container.hasEditSupplier.supplierName } : null
    })
    const [isError, setIsError] = useState({
        supplier_selected: false
    })

    const handleChange = (event) => {
        if (discountScheme_container.hasEditSupplier) {
            setState({ ...state, defaultmode: true })
        }
        setIncluded(event.target.checked);
    };

    const [open, setOpen] = useState(onShow);

    const handleClose = () => {
        setState({ ...state, defaultmode: true })
        dispatch(handleModalState({
            key: 'addEditSupplierModal',
            value: false
        }))
        dispatch(setDiscountSchemeState({
            key: 'hasEditSupplier',
            value: null
        }))
        dispatch(setMemberCode({
            key: 'smaSupplierNameOnModal',
            value: ""
        }))
    };

    const handleSelf = () => {
        handleClose()
    }

    useEffect(() => {
        const fetchMyAPI = async () => {
            if (supplier.supplier_options.length === 0) {
                axios_supplier.get('/supplier/look-up')
                    .then(function (response) {
                        // handle success
                        const { status, data } = response;
                        if (data) {
                            const unique = data.filter((value, index, self) => self.findIndex((m) => m.name === value.name) === index);
                            setSupplier({ ...supplier, supplier_options: unique })
                        }
                    })
                    .catch(function (error) {
                        // handle error
                        console.log(error)
                    });
            }
        }
        fetchMyAPI();
    }, [])

    useEffect(() => {
        if (supplier.supplier_selected === null || supplier.supplier_selected === "") {
            setState({ ...state, formValid: true, defaultmode: false })
        } else {
            setState({ ...state, formValid: false, defaultmode: true })
        }
    }, [supplier.supplier_selected])

    useEffect(() => {
        const {
            supplier_selected
        } = isError
        if (!supplier_selected) {
            setState({ ...state, formValid: false })
        } else {
            setState({ ...state, formValid: true })
        }
    }, [isError])

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (supplier.supplier_selected === null && isError.supplier_selected === false) {
            setIsError({ ...isError, supplier_selected: true })
        } else {
            addPayDate()

        }

    }

    const addPayDate = async () => {
        let payload = null;
        if ((discountScheme_container.hasEditData !== null || discountScheme_container.editTabData !== null) && discountScheme_container.hasEditSupplier === null) {
            payload = {
                "supplierId": supplier.supplier_selected ? supplier.supplier_selected.id : "",
                included,
                "supplierName": supplier.supplier_selected ? supplier.supplier_selected.name : "",
            }
        } else if (discountScheme_container.hasEditSupplier !== null) {
            payload = {
                "id": discountScheme_container.hasEditSupplier.id,
                "supplierId": supplier.supplier_selected ? supplier.supplier_selected.id : discountScheme_container.hasEditSupplier.supplierId,
                included,
                "supplierName": supplier.supplier_selected ? supplier.supplier_selected.name : discountScheme_container.hasEditSupplier.supplierName
            }
        }


        try {
            setState({ ...state, pageLoader: true })
            const { data } = ((discountScheme_container.hasEditData !== null || discountScheme_container.editTabData !== null) && discountScheme_container.hasEditSupplier === null) ? await axiosDiscountSchemes.post(`/discountSchemes/${discountScheme_container.hasEditData.id || discountScheme_container.editTabData.id}/suppliers`, payload) : await axiosDiscountSchemes.put(`/discountSchemes/${discountScheme_container.hasEditData.id || discountScheme_container.editTabData.id}/suppliers/${discountScheme_container.hasEditSupplier.id}`, payload)

            if (data) {
                onSubmitDate({ text: data.message, type: "success" })
                setState({ ...state, pageLoader: false })
                handleClose()
            }

        } catch (error) {
            const { response: { data, status } } = error;
            if (!data) {
                onSubmitDate({ text: error.message, type: "error" })
            } else {
                onSubmitDate({ text: data.message, type: "error" })
            }
            setState({ ...state, pageLoader: false })
            handleClose()
        }
    }

    useEffect(() => {
        if (discountScheme_container.hasEditSupplier !== null) {
            dispatch(setMemberCode({
                key: 'smaSupplierNameOnModal',
                value: discountScheme_container.hasEditSupplier.supplier
            }))
            setIncluded(discountScheme_container.hasEditSupplier.included)
            setState({ ...state, supplierDetail: discountScheme_container.hasEditSupplier.supplier })
        }
    }, [])


    // const hideSupplierMemberModal = (params) => {
    //     setState({ ...state, supplierListModal: params === false ? params : true })
    // }
    // const CommonPopUpModal = () => {
    //     setState({ ...state, supplierListModal: true })
    // }
    // const getsupplierDetail = (supplier) => {
    //     if (supplier !== '') {
    //         setState({ ...state, defaultmode: true, supplierDetail: supplier, supplierListModal: false })
    //     }
    // }

    return (
        <>


            <Modal
                open={open}
                aria-labelledby="add-edit-price-title"
                aria-describedby="add-edit-price-description"
                keepMounted
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <form onSubmit={(e) => handleSubmit(e)}>
                    <Box component="div" className="overlay" id="addEditModal">
                        {state.pageLoader && <PageLoader />}
                        <div className={`overlay-box ${size ? size : ''}`}>
                            <div className="content">
                                <div className="overlayBody">
                                    <div className="overlay-header text-center"> Supplier
                                        <CancelIcon className="closeBtn" onClick={handleClose} />
                                    </div>
                                    <div className="overlay-content">
                                        <Grid item xs={12} md={12}>
                                            <Item sx={{ marginBottom: 2.5 }}>
                                                <Grid container alignItems="center">
                                                    <Grid item xs={12} md={4.5} sx={{ textAlign: 'right' }}>
                                                        <Item>
                                                            <FormLabel htmlFor="type" className="fontSemiBold mandatory">Supplier</FormLabel>
                                                        </Item>
                                                    </Grid>
                                                    <Grid item xs={12} md={7.5}>
                                                        <Item>
                                                            <Autocomplete
                                                                defaultValue={supplier.supplier_selected ? supplier.supplier_selected : null}
                                                                id="supplier_search"
                                                                options={supplier.supplier_options}
                                                                getOptionLabel={(option) => option.name || ""}
                                                                componentsProps={{
                                                                    paper: {
                                                                        sx: {
                                                                            fontSize: '0.85rem'
                                                                        }
                                                                    }
                                                                }}
                                                                onChange={(event, newValue) => {
                                                                    (isError['supplier_selected'] === null || isError['supplier_selected'] === "") ? setIsError({ ...isError, supplier_selected: true }) : setIsError({ ...isError, supplier_selected: false })
                                                                    if (event.target.value !== undefined) {
                                                                        setState({ ...state, defaultmode: true })
                                                                        setSupplier({ ...supplier, supplier_selected: newValue })
                                                                        setIsError({ ...isError, supplier_selected: false })
                                                                    } else {
                                                                        setIsError({ ...isError, supplier_selected: true })
                                                                    }
                                                                }}
                                                                renderInput={(params) =>
                                                                    <FormControl size={'small'} fullWidth>
                                                                        <div className="input-group">
                                                                            <TextField {...params}
                                                                                size="small"
                                                                                id="supplier"
                                                                                aria-describedby="supplier-error"
                                                                                error={isError.supplier_selected}
                                                                            />
                                                                            {isError.supplier_selected && (<FormHelperText className='errorHelperTxt' id="supplier-error">
                                                                                Please select supplier
                                                                            </FormHelperText>)}
                                                                        </div>
                                                                    </FormControl>
                                                                }
                                                            />
                                                        </Item>
                                                    </Grid>
                                                </Grid>
                                            </Item>
                                            <Item sx={{ marginBottom: 2.5 }}>
                                                <Grid container alignItems="center">
                                                    <Grid item xs={12} md={4.5} sx={{ textAlign: 'right' }}>
                                                        <Item>
                                                            <FormLabel htmlFor="included" className="fontSemiBold">Include/Exclude</FormLabel>
                                                        </Item>
                                                    </Grid>
                                                    <Grid item xs={12} md={7.5}>
                                                        <Item>
                                                            <div className="input-group">
                                                                <Checkbox
                                                                    checked={included}
                                                                    onChange={handleChange}
                                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                                />
                                                            </div>
                                                        </Item>
                                                    </Grid>
                                                </Grid>
                                            </Item>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Item sx={{ marginBottom: 2.5 }}>
                                                <Grid container alignItems="center">
                                                    <Grid item xs={12} md={4.5} sx={{ textAlign: 'right' }}>
                                                        <Item>
                                                            &nbsp;
                                                        </Item>
                                                    </Grid>
                                                    <Grid item xs={12} md={7.5}>
                                                        <Item>
                                                            <Grid container direction="row" alignItems="center">
                                                                <Button
                                                                    variant="contained"
                                                                    type="submit"
                                                                    sx={{ marginRight: '15px' }}
                                                                    //disabled={((discountScheme_container.hasEditSupplier && discountScheme_container.hasEditSupplier.confirmed === true) ? true : false) || state.defaultmode === false}
                                                                    // eslint-disable-next-line max-len
                                                                    disabled={((discountScheme_container.hasEditData !== null || discountScheme_container.editTabData !== null) && discountScheme_container.hasEditSupplier) ? isError.supplier_selected : (state.formValid || state.defaultmode === false)}
                                                                >Save</Button>
                                                                <Button variant="outlined" onClick={handleSelf}>Cancel</Button>
                                                            </Grid>
                                                        </Item>
                                                    </Grid>
                                                </Grid>
                                            </Item>
                                        </Grid>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* {
                            state.supplierListModal && <CommonPopUp
                                onShow={state.supplierListModal}
                                size="large_overlay"
                                supplierMemberCode={{
                                    title: 'Supplier Details',
                                    type: 'supplier'
                                }}
                                onHide={hideSupplierMemberModal}
                                memberaccount={getsupplierDetail}
                            />
                        } */}
                    </Box>
                </form>

            </Modal>
        </>
    );
}

export default AddEditSupplier;